<template>
  <div>
    <el-table v-loading="loading" :data="dataList" :height="height">
      <el-table-column label="联系人姓名" min-width="90" align="center">
        <template slot-scope="scope">
          <el-link type="primary" class="crm-link-wrap" :underline="false" @click="toDetail(scope.row)">{{scope.row.contactName}}</el-link>
        </template>
      </el-table-column>
      <el-table-column label="角色" width="80" align="center" prop="roleName" />
      <el-table-column label="公司" width="120" align="center" prop="customerName" />
      <el-table-column label="部门" min-width="100" align="center" prop="apartment" />
      <el-table-column label="职位" min-width="80" align="center" prop="position" />
      <el-table-column label="立场" width="80" align="center" prop="standScore" />
      <el-table-column label="项目影响力" min-width="80" align="center" prop="projectInfluenceDesc" />
      <el-table-column label="倾向" min-width="80" align="center" prop="inclinationDesc" />
      <el-table-column label="是否直接沟通" min-width="80" align="center" prop="directCommunicationDesc" />
      <el-table-column label="沟通频率" min-width="80" align="center" prop="communicationFrequencyDesc" />
      <el-table-column label="公司诉求" min-width="120" align="center" :show-overflow-tooltip="true" prop="companyDemand" />
      <el-table-column label="个人诉求" min-width="120" align="center" :show-overflow-tooltip="true" prop="personalDemand" />
      <el-table-column label="备注" min-width="120" align="center" :show-overflow-tooltip="true" prop="remark" />
      <el-table-column label="操作" width="100" align="center" fixed="right" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-button type="text" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button type="text" @click="handleDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <AddBusinessContactDialog ref="addBusinessContactDialogRef" @success="queryList('change')"></AddBusinessContactDialog>
  </div>
</template>

<script>

import { queryBusinessContact, changeBusinessContact } from '@/api/crm/business'
import AddBusinessContactDialog from "@/views/crm/business/addBusinessContactDialog";

export default {
  name: "BusinessContactList",
  props: {
    businessId: {},
    customerId: {},
    height: {
      type: String,
      default () {
        return "250"
      }
    }
  },
  data() {
    return {
      loading: false,
      dataList: [],
      contactList: [],
      updateData: {
        id: null,
        businessId: null,
        type: null,
        contactId: null
      },
      updateRules: {
        contactId: [
          {required: true, type: 'number', message: '请选择更改后联系人', trigger: 'change'}
        ]
      }
    };
  },
  created() {
    if (this.businessId) {
      this.queryList();
    }
  },
  components: {
    AddBusinessContactDialog
  },
  watch: {
    businessId (val) {
      if (val) {
        this.queryList();
      } else {
        this.dataList = []
      }
    },
    visible (val) {
      if (!val) {
        this.resetForm("updateForm");
      }
    }
  },
  methods: {
    queryList (type) {
      this.loading = true;
      queryBusinessContact({id: this.businessId}).then(response => {
        this.dataList = response.data;
        this.$emit('after-query', response.data || []);
        this.loading = false;
        }
      ).catch(error => {
        this.loading = false;
      })
      if (type === 'change') {
        this.$emit('after-change');
      }
    },
    /** 详细按钮操作 */
    toDetail(row) {
      window.open("/crm/contact/detail/" + row.contactId, "_blank")
    },
    handleDelete(row) {
      this.updateData = row;
      this.updateData.delFlag = 1;
      this.updateData.businessId = this.businessId
      this.$confirm('确认移除该联系人(' + row.contactName + ')吗？', '提示', {confirmButtonText: '确认'}).then(() => {
        const loading = this.$loading({lock: true, text: '加载中', spinner: 'el-icon-loading'});
        changeBusinessContact(this.updateData).then(response => {
          // 刷新页面
          this.queryList()
          this.$emit('after-change');
          this.msgSuccess("操作成功");
        }).finally(() => {
          loading.close()
        })
      }).catch(() => {
      });
    },
    handleEdit(row) {
      this.$refs.addBusinessContactDialogRef.open(this.businessId, row);
    },
    confirm () {
      this.$refs['updateForm'].validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '加载中',
            spinner: 'el-icon-loading'
          });
          changeBusinessContact(this.updateData).then(response => {
            this.queryList();
            this.$emit('after-change');
            loading.close();
            this.msgSuccess("联系人更改成功");
          }).catch(error => {
            loading.close()
          })
        } else {
          this.msgWarning("请检查必填项");
          return false;
        }
      });
    }
  }
};
</script>
